import { makeStyles } from '@material-ui/core';

import breakpoints from 'configs/breakpoints';

import styled from 'shared/utils/styled';

import Textearea from 'components/controls/textarea';

type TextareaAccessories = Partial<{
  error: boolean;
}>;

export const StyledTextarea = styled(Textearea, {
  shouldForwardProp: (prop) => prop !== 'error',
})<TextareaAccessories>(({ error = false }) => ({
  display: 'block',
  width: '100%',
  minHeight: 100,
  padding: 9,
  fontSize: 14,
  fontFamily: 'NeoSansStd',
  border: '1px solid rgba(34, 64, 96, .2)',
  ...(error && {
    borderColor: '#A51010',
  }),
}));

export const Counter = styled('span')(() => ({
  fontSize: 14,
}));

export const SendingMethodItem = styled('div')(() => ({
  display: 'flex',
  alignItems: 'flex-start',
  marginBottom: 10,
  '&:last-child': {
    marginBottom: 0,
  },
}));

export const CheckboxLabel = styled('span')(({ theme }) => ({
  marginLeft: 7,
  marginTop: 1.5,
  fontSize: 14,
  fontFamily: 'NeoSansStd',
  color: '#224060',
}));

export const Label = styled('span')(() => ({
  display: 'block',
  marginBottom: 10,
  fontSize: 14,
  fontWeight: 600,
  color: '#224060',
}));

export const DatepickerLabel = styled(Label)(() => ({
  marginBottom: 7,
}));

export const TopBar = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  [theme.breakpoints.down(breakpoints.xs)]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
}));

export const ButtonsWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginLeft: 40,
  marginBottom: 17,
  [theme.breakpoints.down(breakpoints.xs)]: {
    marginLeft: 0,
  },
}));

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: 15,
  [theme.breakpoints.down(breakpoints.sm)]: {
    flexDirection: 'column',
  },
}));

export const FormContainer = styled('div')(({ theme }) => ({
  maxWidth: '70%',
  width: '100%',
  [theme.breakpoints.down(breakpoints.sm)]: {
    maxWidth: '100%',
  },
}));

export const FieldWrapper = styled('div')(() => ({
  marginBottom: 30,
  '&:last-child': {
    marginBottom: 0,
  },
}));

export const CheckboxContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  marginTop: 30,
  [theme.breakpoints.down(breakpoints.sm)]: {
    flexDirection: 'column',
  },
}));

export const CheckboxList = styled('div')(({ theme }) => ({
  [theme.breakpoints.down(breakpoints.sm)]: {
    width: '100%',
    marginBottom: 30,
    marginLeft: 0,
  },
}));

export const RecipientsContainer = styled('div')(({ theme }) => ({
  maxWidth: 'calc(30% - 15px)',
  width: '100%',
  [theme.breakpoints.down(breakpoints.sm)]: {
    maxWidth: '100%',
  },
}));

export const DatepickerControlWrapper = styled('div')(() => ({
  maxWidth: 150,
}));

export const SectionTitle = styled('span')(({ theme }) => ({
  display: 'block',
  marginBottom: 20,
  fontSize: 16,
  fontWeight: 600,
  fontFamily: 'NeoSansStd',
  lineHeight: '20px',
  color: '#224060',
}));

export const MockSectionTitle = styled('span')(() => ({
  marginBottom: 20,
  display: 'block',
  minHeight: 20,
}));

export const useStyles = makeStyles((theme) => ({
  saveBtn: {
    marginRight: 20,
    background: theme.custom.accept,
  },
  closeBtn: {
    background: '#7E8483',
  },
  datepicker: {
    border: '1px solid rgba(34, 64, 96, .2)',
  },
}));
